<option value="">Auswählen...</option>
<option *ngFor="let file of dashboard.files" [selected]="selected === file.uuid"
        [value]="file.uuid">{{file.name}}</option>


